import { gql } from '@apollo/client';

/**
 * Журнал поиска работы (ТЗ 0069).
 *
 * Имена операций отличаются от имён полей бэкенда и уникальны на весь проект:
 * по ним же работает `refetchQueries`, и тёзка перезапросил бы не то.
 *
 * 🔴 Набор полей выписан в каждой мутации ПОЛНОСТЬЮ, а не подставлен
 * константой через `${…}`: кодоген парсит gql-литералы СТАТИЧЕСКИ и
 * интерполированный документ просто пропускает — молча, без единого слова в
 * выводе. Хуки при этом не появляются, и узнаётся об этом только по ошибке
 * компиляции в месте использования.
 */

/**
 * Завести отклик.
 *
 * `duplicate: true` — ШТАТНЫЙ ответ, а не ошибка: повтор на ту же вакансию,
 * пока прежний отклик ещё в работе, возвращает существующую строку.
 */
export const TrackJobApplicationMutation = gql`
  mutation TrackJobApplication($input: CareerApplicationInput!) {
    createCareerApplication(input: $input) {
      success
      duplicate
      application {
        id
        vacancyId
        companyName
        position
        applyUrl
        status
        appliedAt
        nextActionAt
        note
        source
        isPlacementConfirmed
        createdAt
        updatedAt
      }
      customErrors {
        code
        field
        message
      }
    }
  }
`;

export const ReviseJobApplicationMutation = gql`
  mutation ReviseJobApplication($id: ID!, $input: CareerApplicationInput!) {
    updateCareerApplication(id: $id, input: $input) {
      success
      application {
        id
        vacancyId
        companyName
        position
        applyUrl
        status
        appliedAt
        nextActionAt
        note
        source
        isPlacementConfirmed
        createdAt
        updatedAt
      }
      customErrors {
        code
        field
        message
      }
    }
  }
`;

/**
 * Сменить статус.
 *
 * 🔴 `hired` НЕ создаёт запись о трудоустройстве и НЕ меняет статус участника
 * центра — он лишь ставит отклик в очередь подтверждения сотруднику. Отсюда и
 * формулировка на экране: «сообщить школе», а не «подтвердить».
 */
export const MoveJobApplicationMutation = gql`
  mutation MoveJobApplication($id: ID!, $status: String!) {
    setCareerApplicationStatus(id: $id, status: $status) {
      success
      application {
        id
        vacancyId
        companyName
        position
        applyUrl
        status
        appliedAt
        nextActionAt
        note
        source
        isPlacementConfirmed
        createdAt
        updatedAt
      }
      customErrors {
        code
        field
        message
      }
    }
  }
`;

export const DropJobApplicationMutation = gql`
  mutation DropJobApplication($id: ID!) {
    deleteCareerApplication(id: $id) {
      success
      deleted
      customErrors {
        code
        field
        message
      }
    }
  }
`;
